import {Component, inject, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute} from '@angular/router';
import {ContextService} from '@services/context.service';
import * as FileSaver from 'file-saver';
import {ContextModel} from '@app/models/context.model';
import {EnvironmentsService} from '@services/environments.service';

@Component({
  template: `
    <div style="padding-top:300px ">
      @if(!doneDownloading) {
        <span class="fa fa-spinner list-spinner" style="margin-left:10px;"></span>
        <h3 style="text-align:center; width:100%">Downloading File</h3>
      } @else {
        <h3 style="text-align:center; width:100%">Download Complete</h3>
      }

    </div>

  `,
  standalone: true
})
export class FileDownloadUrlComponent implements OnInit  {
  private http = inject(HttpClient);
  token: string;
  baseUrl: string;
  doneDownloading: boolean = false;
  constructor(private route:ActivatedRoute, private contextService: ContextService, private environmentsService: EnvironmentsService) {

  }

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
        this.token = params.get('token');
        if (this.token) {
          this.getBaseUrl();

        }
    });
  }


  ////// do not delete this file. used for getting token and api for file download

  getDocument() {
    // eslint-disable-next-line @typescript-eslint/ban-types
    const requestOptions: Object = {
      responseType: 'arraybuffer'
    };
    this.http.get(`${this.baseUrl}/api/1.0/document/download?token=${this.token}`, requestOptions).subscribe({
      next: (res) => {
        this.downloadFile(res, 'download.pdf', 'text/plain;charset=utf-8');
      },
      error: (err) => {
        console.error('Error fetching data', err);
      }
    });
  }

  downloadFile(buffer, fileName, fileType) {
    import('file-saver').then(() => {
      const data: Blob = new Blob([buffer], {
        type: fileType
      });
      FileSaver.saveAs(data, fileName);
      this.doneDownloading = true;
      window.top.close();
    });
  }

  getBaseUrl() {
    return new Promise((resolve, reject) => {
      this.environmentsService.getEnvironment(window.location.hostname).then((rtnTenant) => {
        if (rtnTenant) {
          console.log('rtnTenant', rtnTenant);
          this.baseUrl = rtnTenant.apiBaseUrlV1;
          this.getDocument();
        }

      });
      resolve(null);
    });
  }



}
